export interface Empfaenger {
  id: number;
  name: string;
}
